export default function createActivitiesStyle() {
  return {
    margin: 0,
    padding: 0
  };
}
